import { Link } from "react-router-dom";
import {
  // ArrowRight,
  // Facebook,
  // Linkedin,
  Mail,
  MapPin,
  Phone,
  // Twitter,
  // Youtube,
} from "lucide-react";
import { FaLinkedin} from "react-icons/fa";
import { Springuplogo } from "../../theme/images";
import "./Footer.css";

const services = [
  { label: "AI Enabled GCC Services", to: "/services/gcc-services" },
  { label: "AI Center of Excellence", to: "/ai-coe" },
  { label: "Cloud Solutions", to: "/services/cloud-solutions" },
  { label: "New Product Development", to: "/services/new-product-development" },
  { label: "Product Support Services", to: "/services/product-support-services" },
  { label: "Engagement Models", to: "/engagement-models" },
  { label: "Process Driven Approach", to: "/process-driven-approach" },
];

const company = [
  { label: "About Us", to: "/about" },
  { label: "Leadership", to: "/leadership" },
  { label: "Life at SpringUp", to: "/life-at-springup" },
  { label: "Clients", to: "/clients" },
  { label: "Client Testimonies", to: "/client-testimonies" },
  { label: "Case Studies", to: "/insights/case-study" },
];

const resources = [
  { label: "Blogs", to: "/blogs" },
  { label: "Contact Us", to: "/contact" },
];

const Footer = () => {
  return (
    <footer className="spf">
      <div className="spf__bg" />
      <div className="spf__grid-bg" />
      <div className="spf__blob spf__blob--1" />
      <div className="spf__blob spf__blob--2" />
      <div className="spf__blob spf__blob--3" />
      <div className="spf__wave" aria-hidden="true">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
          <path
            d="M0,40 C240,80 480,0 720,30 C960,60 1200,20 1440,50 L1440,0 L0,0 Z"
            fill="currentColor"
          />
        </svg>
      </div>

      {/* Main grid */}
      <div className="spf__main">
        <div className="spf__container spf__cols container">
          <div className="spf__brand">
            {/* <Link to="/" className="spf__logo">
              <span className="spf__logo-dot" />
              SpringUp <span className="spf__grad">Labs</span>
            </Link> */}
            <img src={Springuplogo} alt="SpringUp Labs Logo" className="spf__logo-img" />
            <p className="spf__tag">
              An innovative software product development company focusing on modern digital capabilities and data-driven methodologies.
            </p>

            <ul className="spf__contact">
              <li>
                <span className="spf__cicon"><MapPin size={14} /></span>
                <span>SpringUp labs Pvt. Ltd, I2I building, Pallod Farms, Lane-3, near Vijay Sales, Baner, Pune - 411045.</span>
              </li>
              <li>
                <span className="spf__cicon"><Mail size={14} /></span>
                <a href="mailto:info@springuplabs.com"> info@springuplabs.com</a>
              </li>
              <li>
                <span className="spf__cicon"><Phone size={14} /></span>
                <a href="tel:+919209554382">+91 92095 54382</a>
              </li>
            </ul>
          </div>

          <div className="spf__col">
            <h4>Services</h4>
            <ul>
              {services.map((s) => (
                <li key={s.to}><Link to={s.to}>{s.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="spf__col">
            <h4>Company</h4>
            <ul>
              {company.map((s) => (
                <li key={s.to}><Link to={s.to}>{s.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="spf__col spf__col--news">
            <h4>Stay in the loop</h4>
            <p className="spf__news-text">
              We are an innovative software product development company focusing on modern digital capabilities and data-driven methodologies to enhance efficiency and value. We help our customer to realize their investments, while working with customer focus, integrity, and insight; thereby becoming the trusted technology partner in our customer's digital transformation journey.
            </p>
            {/* <form
              className="spf__news"
              onSubmit={(e) => e.preventDefault()}
            >
              <input
                type="email"
                placeholder="you@company.com"
                aria-label="Email address"
                required
              />
              <button type="submit" aria-label="Subscribe">
                <ArrowRight size={16} />
              </button>
            </form> */}

            <ul className="spf__resources">
              {resources.map((s) => (
                <li key={s.to}><Link to={s.to}>{s.label}</Link></li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="spf__bottom">
        <div className="spf__container spf__bottom-inner">
          <p>© {new Date().getFullYear()} SpringUp Labs. All rights reserved.</p>
          <div className="spf__social">
            {/* <a href="#" aria-label="LinkedIn"><Linkedin size={16} /></a> */}
            {/* <a href="#" aria-label="Twitter"><Twitter size={16} /></a> */}
            {/* <a href="#" aria-label="Facebook"><Facebook size={16} /></a> */}
            {/* <a href="#" aria-label="YouTube"><Youtube size={16} /></a> */}
            <a
              href="https://www.linkedin.com/company/springup-labs/posts/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin size={16} />
            </a>

            {/* <a
              href="https://twitter.com/springuplabs"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FaTwitter size={16} />
            </a>

            <a
              href="https://www.facebook.com/springuplabs"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebook size={16} />
            </a> */}

            {/* <a href="https://www.youtube.com/springuplabs" aria-label="YouTube">
              <FaYoutube size={16} />
            </a> */}
          </div>
          <div className="spf__legal">
            <Link to="/privacy-policy" >Privacy Policy </Link> {" | "}
            <Link to="/terms-of-use">Terms of Use</Link> {" | "}
            <Link to="/cookies-policy">Cookies Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
